function unixTimeSecondsToDate(unixSeconds) {
    const d = new Date(1970, 0, 1); // Epoch
    d.setSeconds(unixSeconds);
    return d;
}
function dateToUtcDateStamp(d) {
    const utcMonth = d.getUTCMonth() + 1;
    const utcMonthStr = `${utcMonth}`;
    const utcMonthStrPadded = utcMonthStr.padStart(2, "0");
    const utcDate = d.getUTCDate();
    const utcDateStr = `${utcDate}`;
    const utcDateStrPadded = utcDateStr.padStart(2, "0");
    return `${d.getUTCFullYear()}-${utcMonthStrPadded}-${utcDateStrPadded}`;
}
export function unixTimeSecondsToUtcDateStamp(unixSeconds) {
    return dateToUtcDateStamp(unixTimeSecondsToDate(unixSeconds));
}
export function unixTimeSecondsToUtcTimestamp(unixSeconds) {
    const date = unixTimeSecondsToDate(unixSeconds);
    return date.toISOString();
}
